require("./gallery.js");

import "./widget.scss";
